export default __webpack_public_path__ + "f75fab77b4d068f8e21825abfaec8cd1.svg";